import React, { useEffect, useState } from "react";
import Header from "../../../../../Componets/Header";
import Status from "../../../../../Componets/Status";
import ActionButton from "../../../../../Componets/Buttons/action";
import Table from "../../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../../Data/Tables/Tax/Tax_Types/tables";
import headers from "../../../../../Data/Tables/Tax/Tax_Types/headers";
import Loadercomponent from "../../../../../Componets/Loader";
import { get_all_tax_types } from "../../../../../Controllers/Tax/Tax_Types";
import moment from "moment";

const TaxTypesTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};

    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const taxTypes = await get_all_tax_types(params);

      if (taxTypes?.status) {
        let data = [];

        taxTypes?.data?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Code: value?.code,
            Description: value?.description || "-",
            Status: (
              <Status
                status={value?.status}
                active="Active"
                inactive="Inactive"
              />
            ),
            "Created Date": moment(value?.createdAt).format("DD-MM-YYYY"),
            Action: (
              <ActionButton
                edit={`/app/settings/tax/types/edit/${value?._id}`}
                id={value?._id}
                api="delete-tax-type"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: taxTypes?.data?.currentPage,
          totalCount: taxTypes?.data?.totalCount,
          totalPages: taxTypes?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(taxTypes?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });

    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default TaxTypesTable;